// extracted by mini-css-extract-plugin
module.exports = {"__body":"__body--Dpva3","__footerbtn":"__footerbtn--e1C1Q"};